import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

const faqs = [
  { q: "How do I get an expedited passport in Fairbanks, Alaska?", a: "Fairbanks residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents overnight and we handle agency submission remotely. The nearest regional agency is in Seattle, over 1,600 miles away." },
  { q: "Where is the nearest passport agency to Fairbanks?", a: "The Seattle Regional Passport Agency (915 2nd Ave, Seattle, WA 98174) is the nearest agency to Fairbanks — requiring a full flight. Fast Passport Center eliminates that trip entirely." },
];

export default function FairbanksPage() {
  return (
    <>
      <CitySEOHead
        city="Fairbanks"
        state="Alaska"
        stateAbbr="AK"
        route="/cities/fairbanks-ak"
        title="Expedited & Emergency Passport Services Fairbanks AK | Fast Passport Center"
        description="Fast Passport Center provides emergency, expedited, and same-day passport services in Fairbanks, Alaska. Serving Fairbanks North Star Borough, North Pole, Fort Wainwright, Eielson AFB, and all Interior Alaska. As fast as 24 hours — no Seattle agency trip needed."
        geoPlacename="Fairbanks, Alaska"
        geoPosition="64.8378;-147.7164"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Alaska"
        statePageRoute="/states/alaska"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <StickyNav />
        <ProcessingTimeSection />
        <ServicesSection />
        <HowItWorksSection />
        <LocalAreaSection />
        <TestimonialsSection />
        <AcceptanceFacilitiesSection />
        <ComparisonSection />
        <MistakesSection />
        <FAQSection />
        <HelpfulResourcesSection />
        <FinalCTA />
      </div>
    </>
  );
}